module.exports = __webpack_public_path__ + "img/careers.781597d.jpg";